<template>
  <div>
    <HelpComponent></HelpComponent>
  </div>
</template>

<script>
const HelpComponent = () =>
  import("../../components/dashboard/helpComponent");
export default {
  name: "help",
  components: { HelpComponent },
};
</script>

<style scoped></style>
